(() => {
  let observer;
  let resizeObserver;
  const setup = () => {
    observer?.disconnect();
    resizeObserver?.disconnect();
    const sticky = document.querySelector('[data-ml-sticky]');
    const productStart = document.getElementById('melena-product-start');
    const boxes = document.getElementById('melena-buy-boxes');
    if (!sticky || !productStart || !boxes) {
      if (sticky) sticky.hidden = true;
      document.body.style.setProperty('--ml-sticky-height', '0px');
      return;
    }
    const reserveSpace = () => {
      if (!sticky.hidden) document.body.style.setProperty('--ml-sticky-height', `${Math.ceil(sticky.getBoundingClientRect().height)}px`);
    };
    sticky.hidden = false;
    reserveSpace();
    resizeObserver = new ResizeObserver(reserveSpace);
    resizeObserver.observe(sticky);
    const productSections = [...new Set([
      productStart,
      document.querySelector('[data-testid="product-information"]'),
      boxes
    ].filter(Boolean).map(element => element.closest('.shopify-section') || element))];
    const visibility = new Map(productSections.map(element => {
      const bounds = element.getBoundingClientRect();
      return [element, bounds.bottom > 0 && bounds.top < window.innerHeight];
    }));
    const updateVisibility = () => {
      sticky.hidden = [...visibility.values()].some(Boolean);
    };
    updateVisibility();
    observer = new IntersectionObserver(entries => {
      entries.forEach(entry => visibility.set(entry.target, entry.isIntersecting));
      updateVisibility();
    }, { threshold: 0 });
    productSections.forEach(element => observer.observe(element));
  };
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[href="#melena-product-start"], a[href="#melena-buy-boxes"]');
    if (!link || !document.body.classList.contains('ml-landing')) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  });
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(setup));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
